// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"56":"Reports","543":"data","594":"about","623":"TreatmentTracker","648":"hospitals","962":"home"}[chunkId] || chunkId) + "." + {"56":"0387d444","543":"c56fba08","576":"4db47f9b","594":"2f8a197c","623":"93e5cd8d","648":"399aa80c","748":"d3839356","962":"0fd555a6"}[chunkId] + ".css";
};